import { normalizeNumberInputValue } from 'src/common/utils/decimal-input';

type TInputEvent = {
  target: {
    value: string;
  };
};

type TFieldOnChange = (value: string | number) => void;
type TOnChange = (event: TInputEvent) => void;

export const onChangeInput = (e: TInputEvent, type: string, fieldOnChange: TFieldOnChange, onChange?: TOnChange) => {
  const { value } = e.target;
  if (type === 'number') {
    fieldOnChange(normalizeNumberInputValue(value));
  } else {
    fieldOnChange(value);
  }

  if (onChange) {
    onChange(e);
  }
};

export const onChangeNumberInput = (event: TInputEvent, fieldOnChange: TFieldOnChange, onChange?: TOnChange) => {
  const { value } = event.target;
  fieldOnChange(normalizeNumberInputValue(value));

  if (onChange) {
    onChange(event);
  }
};
